import { render, staticRenderFns } from "./system-manage.vue?vue&type=template&id=56f32c5a&scoped=true&"
import script from "./system-manage.vue?vue&type=script&lang=js&"
export * from "./system-manage.vue?vue&type=script&lang=js&"
import style0 from "./system-manage.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./system-manage.vue?vue&type=style&index=1&id=56f32c5a&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f32c5a",
  null
  
)

export default component.exports